Warehouse Code,Warehouse Name,Other Metadata,LatLong
Test1,Warehouse1,Other,"12.103935, 75.203317 "
Test2,Warehouse2,,"11.223009, 75.916767"
Test3,Warehouse3,,"10.611986, 76.060854"
Test4,Warehouse4,,"10.791631, 76.734400"
Test5,Warehouse5,,"9.604165206207492, 76.46273514013502"
Test6,Warehouse6,,"8.90924026334939, 76.64508397263933"
Test7,Warehouse7,,"8.4687501640205, 77.01602520988526"